








import { defineComponent, ref } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ColumnType } from '~/types/solepro/PageBuilder';

export default defineComponent({
    name: "ColumnLine",
    mixins: [PageBuilderComponent],
    components: {
        PageBuilderComponent
    },
    props: {
        node: {
            type: Object as PropType<ColumnType>,
            required: true
        }
    },
    setup(props) {
        const { node: content } = props;
        const WrapperComponent = content.tagname.toLowerCase();
        const colsClass = ref('')
        return {
            WrapperComponent,
            content,
            colsClass

        }
    },
    mounted(){
           const parent = this.$el.closest('.pb_column-group') as HTMLElement;
           if (Array.from(parent.classList).includes('!grid') ) this.colsClass = `!grid grid-cols-${parent.dataset.gridSize}`
    }
})
